import { Link } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { GUIDE_STEPS } from '../constants/content';

export default function GuidePage() {
  return (
    <>
      <PageHero
        title="使用流程"
        subtitle="四步开启属于你的冥想练习之旅，零基础也能轻松上手。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '使用流程' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          {GUIDE_STEPS.map((item) => (
            <AnimatedCard
              key={item.step}
              className="bg-white/5 rounded-2xl p-8 border border-purple-500/20"
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-full bg-gradient-to-r from-primary to-secondary flex items-center justify-center shrink-0">
                  <span className="text-xl font-bold">{item.step}</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                  <p className="text-purple-200 text-sm mb-3">{item.desc}</p>
                  <p className="text-purple-300 text-sm leading-relaxed">{item.detail}</p>
                </div>
              </div>
            </AnimatedCard>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl font-bold mb-6 text-center">练习前准备</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { icon: 'fa-heart', text: '选择安静、不被打扰的空间' },
              { icon: 'fa-headphones', text: '建议佩戴耳机，获得更好引导体验' },
              { icon: 'fa-clock-o', text: '预留 5-30 分钟，根据课程时长安排' },
              { icon: 'fa-leaf', text: '不必追求完美，允许念头自然来去' },
            ].map((tip) => (
              <div
                key={tip.text}
                className="flex items-start gap-3 bg-white/5 rounded-xl p-4 border border-purple-500/20"
              >
                <i className={`fa ${tip.icon} text-secondary mt-1`} />
                <p className="text-purple-200 text-sm">{tip.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-2xl mx-auto bg-gradient-to-r from-primary/10 to-pink-500/10 rounded-2xl p-6 border border-purple-500/20 text-center mb-16">
          <p className="text-purple-200 text-sm">
            <i className="fa fa-info-circle text-secondary mr-1" />
            冥想是技能而非天赋，坚持练习比单次时长更重要。从每天 5 分钟开始，你会感受到变化。
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold mb-6 text-center">下载 APP</h2>
          <p className="text-purple-200 text-center mb-8 text-sm">
            在 iOS App Store 或 Android 应用商店搜索「Ameowzing」即可下载安装。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/features"
              className="inline-flex justify-center items-center bg-white/10 border border-purple-500/30 px-6 py-3 rounded-full hover:bg-white/20"
            >
              了解功能特色
            </Link>
            <Link
              to="/meditation"
              className="inline-flex justify-center items-center bg-white/10 border border-purple-500/30 px-6 py-3 rounded-full hover:bg-white/20"
            >
              浏览冥想课程
            </Link>
            <Link
              to="/support"
              className="inline-flex justify-center items-center bg-white/10 border border-purple-500/30 px-6 py-3 rounded-full hover:bg-white/20"
            >
              需要帮助？
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
